// extracted by mini-css-extract-plugin
export var aiStarIcon = "_dz-4";
export var closeButton = "_dz-6";
export var dismissButton = "_dz-3";
export var editImageWithAiContainer = "_dz-8";
export var imageUploadWrapper = "_dz-7";
export var misspelledWord = "_dz-5";
export var spellCheckContainer = "_dz-2";
export var spin = "_dz-1";
export var spinning = "_dz-0";